###
# Usage
  <wm-select
    items="vm.itemsList"
    search-term="optional.string"
    label="string"
    placeholder-text="optional.string"
    delay="optional.integer"
    attributes-map="vm.object"
    selected-value="optional.id"
    item-template-url="'string'"
    on-change="vm.function"
    on-select="vm.function"
    has-search="optional.bool"
  ></wm-select>

# Attributes purposes
## items - Array of items to display. By default it's ID and NAME keys are displayed. Can be changed using attributesMap.
## search-term - Initial word to be placed in search field.
## label - Field label.
## placeholder-text - Text to placed as placeholder.
## delay - Search function delay in milliseconds after typing letter. [350]
## attributes-map - Map of what attribute should be used as ID and NAME. {id: itemAttribute, name: itemAttribute}. [{id: 'id', name: 'name'}]
## selected-value - Pre-defined ID attribute to be selected.
## item-template-url - Use this template to display each element. Use {{item}} to access current element. [@directive/select/select.item.view.html]
## has-after-select - Toggle after select actions
## on-change - Callback after user has typed anything in search field.
## on-select - Callback after user has clicked on dropdown element.
## has-search - Bool that defines, if input has enabled search.
## search-term - Text placed as a default input value
###

angular
	.module 'App.Directive'
	.directive 'wmSelect', ->
		restrict: 'EA'
		templateUrl: '@directive/input/select/select.view.html'
		scope:
			items: '='
			searchTerm: '=?'
			group: '=?'
			label: '@?'
			placeholderText: '@?'
			delay: '=?'
			attributesMap: '=?'
			selectedValue: '=?'
			itemTemplateUrl: '=?'
			hasAfterSelect: '=?'
			onChange: '&?'
			onSelect: '&?'
			hasSearch: '=?'
			minLength: '@?'
		link: ($scope, $element, attrs) ->
			defaults =
				searchTerm: ''
				placeholderText: 'Start typing'
				delay: 450
				minLength: 0
				attributesMap:
					id: 'id'
					name: 'name'
				selectedValue: ''
				itemTemplateUrl: "@directive/input/select/select.item.view.html"
				hasAfterSelect: true
				hasSearch: true
			angular.forEach defaults, (val, key) ->
				if angular.isUndefined $scope[key]
					$scope[key] = val
		controller: 'SelectController'

###
@deprecated Use DropdownComponent
###
class SelectController extends BaseController
	@register angular.module 'App.Directive'
	@inject '$scope', '$element'

	initialize: ->
		@originItems = null

		@$scope.isActive = false
		@$scope.isLoading = false

	change: ->
		if @$scope.minLength > 0 && @$scope.searchTerm.length < @$scope.minLength
			return

		@$scope.isLoading = true

		if angular.isDefined @$scope.onChange
			Promise
				.resolve @$scope.onChange({term: @$scope.searchTerm})
				.then =>
					@$scope.isLoading = false
		else
			@defaultChange(@$scope.searchTerm)

	select: (item) ->
		if angular.isDefined @$scope.onSelect
			@$scope.onSelect({item: item, group: @$scope.group})
		@afterSelect item

	defaultChange: (searchTerm) ->
		nameAttr = @$scope.attributesMap.name
		@originItems ?= @$scope.items

		if searchTerm.length > 0
			items = []
			term = searchTerm.toLowerCase()
			angular.forEach @originItems, (item) ->
				if (item[nameAttr].toLowerCase().indexOf(term) > -1)
					items.push item
			@$scope.items = items
		else
			@$scope.items = @originItems
		@$scope.isLoading = false

	afterSelect: (item) ->
		if @$scope.hasAfterSelect
			if angular.isObject(@$scope.selectedValue)
				@$scope.selectedValue = item
			else
				@$scope.selectedValue = item[@$scope.attributesMap.id]
			@$scope.searchTerm = item[@$scope.attributesMap.name]
		else
			@$scope.searchTerm = ''
		@setActive(false)

	setActive: (newStatus = true) ->
		@$scope.isActive = newStatus
		return
